export const categories = [
  {
    id: 1,
    name: "Fermetures",
    slug: "fermetures",
    image: "/images/Fermeture.jpg",
    description:
      "Fermetures à glissière, invisibles, ouvrables, chaînes continues et accessoires.",
  },
  {
    id: 2,
    name: "Élastiques",
    slug: "elastiques",
    image: "/images/elastique1cm.jpeg",
    description:
      "Élastiques de différentes largeurs pour confection et habillement.",
  },
  {
    id: 3,
    name: "Fils",
    slug: "fils",
    image: "/images/filcones.jpg",
    description:
      "Fils à coudre, mousse, bobines et fils spécialisés.",
  },
  {
    id: 4,
    name: "Tissus",
    slug: "tissus",
    image: "/images/satin.jpg",
    description:
      "Tissus techniques, satin, doublure, triplure et textiles divers.",
  },
  {
    id: 5,
    name: "Velcro",
    slug: "velcro",
    image: "/images/Velcro2cm.jpeg",
    description:
      "Velcro disponible en plusieurs largeurs pour usages professionnels.",
  },
  {
    id: 6,
    name: "Boutons",
    slug: "boutons",
    image: "/images/Boutonsrecouvrir.jpeg",
    description:
      "Boutons à recouvrir, accessoires et machines spécialisées.",
  },
  {
    id: 7,
    name: "Accessoires Rideaux",
    slug: "accessoires-rideaux",
    image: "/images/oeillets.jpg",
    description:
      "Tresses, œillets et accessoires pour confection de rideaux.",
  },
  {
    id: 8,
    name: "Ciseaux",
    slug: "ciseaux",
    image: "/images/ciseau8.jpg",
    description:
      "Ciseaux professionnels pour couture et découpe textile.",
  },
  {
    id: 9,
    name: "Accessoires Tapissier",
    slug: "accessoires-tapissier",
    image: "/images/Cloust50.webp",
    description:
      "Clous, graphes et accessoires destinés aux tapissiers.",
  },
  {
    id: 10,
    name: "Divers",
    slug: "divers",
    image: "/images/Epingle.jpeg",
    description:
      "Mercerie, outils, craies, aiguilles et nombreux accessoires.",
  },
]